<section class="d-flex flex-column align-items-center justify-content-center auth-section">
    <div class="loader-container">
        <div>Please wait while we are fetching your details...</div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</section>